@for (option of dataArray; track option) {
  <span [ngClass]="option.class" [hidden]="!option.text && !option.iconSrc">
    @if (option.iconSrc) {
      <img [src]="option.iconSrc" style="height:15px" alt="" />
    }
    {{ option.text }}
    <i style="padding-left: 5px" [hidden]="!option.ngbPopover" [ngClass]="option.ngbPopoverClass"
      class="fas fa-info-circle" [ngbPopover]="popContent" container="body"
      triggers="mouseenter:mouseleave"></i>
    <ng-template #popContent>
      <div [innerHTML]="sanitizerHtml(option.ngbPopover)"></div>
    </ng-template>
  </span>
}
